import { httpClient } from './httpClient';
import type { PaymentRepository, CreatePaymentIntentParams } from '@/domain/port/PaymentRepository';
import type { PaymentMethod } from '@/domain/model/PaymentMethod';
import type { PaymentIntent } from '@/domain/model/PaymentIntent';
import type { PaymentTransaction } from '@/domain/model/PaymentTransaction';
import type { SavedPaymentMethod } from '@/domain/model/SavedPaymentMethod';

export class PaymentApiAdapter implements PaymentRepository {
  async getAvailableMethods(): Promise<PaymentMethod[]> {
    const { data } = await httpClient.get<PaymentMethod[]>('/payments/methods');
    return data;
  }

  async createPaymentIntent(params: CreatePaymentIntentParams): Promise<PaymentIntent> {
    const { data } = await httpClient.post<PaymentIntent>('/payments/intent', params);
    return data;
  }

  async confirmPayment(externalPaymentId: string): Promise<PaymentTransaction> {
    const { data } = await httpClient.post<PaymentTransaction>(
      `/payments/confirm/${externalPaymentId}`,
    );
    return data;
  }

  async getPaymentHistory(): Promise<PaymentTransaction[]> {
    const { data } = await httpClient.get<PaymentTransaction[]>('/payments/history');
    return data;
  }

  async getSavedMethods(): Promise<SavedPaymentMethod[]> {
    const { data } = await httpClient.get<SavedPaymentMethod[]>('/payment-methods');
    return data;
  }

  async deleteMethod(id: string): Promise<void> {
    await httpClient.delete(`/payment-methods/${id}`);
  }

  async setDefaultMethod(id: string): Promise<SavedPaymentMethod> {
    const { data } = await httpClient.post<SavedPaymentMethod>(
      `/payment-methods/${id}/set-default`,
    );
    return data;
  }
}
